import { useParams } from "react-router-dom";
import LivePlayer from "../components/match/LivePlayer2";
import LiveScoreCard from "../components/match/LiveScoreCard";
import MatchCard from "../components/match/MatchCard";
import MatchDetails from "../components/match/MatchDetails";
import MatchResultCard from "../components/match/MatchResultCard";
import NoStreamingCard from "../components/match/NoStreamingCard";
import PlayingXI from "../components/match/PlayingXI";
import ServerSelector from "../components/match/ServerSelector";
import StreamNotice from "../components/match/StreamNotice";
import PointsTable from "../components/tournament/PointsTable";
import ViewPointsTableButton from "../components/tournament/ViewPointsTableButton";
import { useState } from "react";
import { useEffect } from "react";
import apiClient from "../utils/apiClient";
import { CircularProgress } from "@mui/material";
import LiveMatch from "../components/match/LiveMatch";
import MatchCards from "../components/match/MatchCards";
import MatchStatistics from "../components/match/MatchStatistics";
import MatchComments from "../components/match/MatchComments";
import MatchOdds from "../components/match/MatchOdds";

const Match = () => {
    const { slug } = useParams();
    const [data, setData] = useState({});
    const [teams, setTeams] = useState([]);
    const [standings, setStandings] = useState([]);

    const [loadingEvents, setLoadingEvents] = useState(true);

    const getDetails = async () => {
        try {
            setLoadingEvents(true);

            const response = await apiClient.get('/public/match/' + slug)
            const result = await response?.data;

            if (result?.success) {
                const matches = Object.values(result.data?.oddsData);
                setData({ 
                    ...result.data?.matchData[0] || {},
                     h2hData: result.data?.h2hData || {},
                     live: result.data?.live || {},
                    live_comments:matches[0]?.live_comments || [],
                    live_odds:matches[0]?.live_odds || []
                    });
            } 

        } catch (error) {
            console.log("Country API Error:", error);
        } finally {
            setLoadingEvents(false);
        }
    };

    useEffect(() => {
        slug && getDetails();
    }, [slug]);

    if (loadingEvents) {
        return (
            <div className="flex justify-center py-6">
                <CircularProgress size={24} />
            </div>
        )
    }

    if (!data?.match_id) {
        return (
            <div className="flex items-center justify-center py-20">
                <div className="text-center">

                    <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
                        Match Not Found
                    </h2>

                    <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                        Please try another match.
                    </p>

                </div>
            </div>
        );
    }

    return (
        <>
            <main className="flex-1 py-6">
                <div className="container mx-auto px-4 max-w-6xl">
                    <LiveMatch data={data?.live}/>
                    <MatchDetails data={data} />
                    {/* <LiveScoreCard /> */}
                    <MatchCards data={{
                        cards: data.cards,
                        info: {
                            team_away_badge: data?.team_away_badge,
                            team_home_badge: data?.team_home_badge,
                            match_awayteam_score: data?.match_awayteam_score,
                            match_hometeam_score: data?.match_hometeam_score,
                            match_awayteam_name: data?.match_awayteam_name,
                            match_hometeam_name: data?.match_hometeam_name,
                            match_awayteam_system: data?.match_awayteam_system,
                            match_hometeam_system: data?.match_hometeam_system,
                        }
                    }} />
                    <MatchComments data={{
                        live_comments: data.live_comments,
                        info: {
                            team_away_badge: data?.team_away_badge,
                            team_home_badge: data?.team_home_badge,
                            match_awayteam_score: data?.match_awayteam_score,
                            match_hometeam_score: data?.match_hometeam_score,
                            match_awayteam_name: data?.match_awayteam_name,
                            match_hometeam_name: data?.match_hometeam_name,
                            match_awayteam_system: data?.match_awayteam_system,
                            match_hometeam_system: data?.match_hometeam_system,
                        }
                    }} />
                    <MatchOdds data={{
                        live_odds: data.live_odds,
                        info: {
                            team_away_badge: data?.team_away_badge,
                            team_home_badge: data?.team_home_badge,
                            match_awayteam_score: data?.match_awayteam_score,
                            match_hometeam_score: data?.match_hometeam_score,
                            match_awayteam_name: data?.match_awayteam_name,
                            match_hometeam_name: data?.match_hometeam_name,
                            match_awayteam_system: data?.match_awayteam_system,
                            match_hometeam_system: data?.match_hometeam_system,
                        }
                    }} />
                    <MatchStatistics data={{
                        statistics: data.statistics,
                        statistics_1half: data.statistics_1half,
                        info: {
                            team_away_badge: data?.team_away_badge,
                            team_home_badge: data?.team_home_badge,
                            match_awayteam_score: data?.match_awayteam_score,
                            match_hometeam_score: data?.match_hometeam_score,
                            match_awayteam_name: data?.match_awayteam_name,
                            match_hometeam_name: data?.match_hometeam_name,
                            match_awayteam_system: data?.match_awayteam_system,
                            match_hometeam_system: data?.match_hometeam_system,
                        }
                    }} />
                    {/* <ViewPointsTableButton /> */}
                    <PlayingXI data={
                        {
                            lineup: data?.lineup,
                            team_away_badge: data?.team_away_badge,
                            team_home_badge: data?.team_home_badge,
                            match_awayteam_score: data?.match_awayteam_score,
                            match_hometeam_score: data?.match_hometeam_score,
                            match_awayteam_name: data?.match_awayteam_name,
                            match_hometeam_name: data?.match_hometeam_name,
                            match_awayteam_system: data?.match_awayteam_system,
                            match_hometeam_system: data?.match_hometeam_system,
                            match_status: data?.match_status,
                            match_live: data?.match_live,
                            league_year: data?.league_year,
                            league_logo: data?.league_logo,
                            league_name: data?.league_name,
                            country_name: data?.country_name,
                            country_logo: data?.country_logo,
                            match_stadium: data?.match_stadium,
                            match_time: data?.match_time,
                            match_date: data?.match_date,
                            stage_name: data?.stage_name,
                        }

                    } />
                    {/* <PointsTable /> */}
                    <MatchCard data={
                        {
                            team_away_badge: data?.team_away_badge,
                            team_home_badge: data?.team_home_badge,
                            match_awayteam_score: data?.match_awayteam_score,
                            match_hometeam_score: data?.match_hometeam_score,
                            match_awayteam_name: data?.match_awayteam_name,
                            match_hometeam_name: data?.match_hometeam_name,
                            match_awayteam_system: data?.match_awayteam_system,
                            match_hometeam_system: data?.match_hometeam_system,
                            match_status: data?.match_status,
                            match_live: data?.match_live,
                            league_year: data?.league_year,
                            league_logo: data?.league_logo,
                            league_name: data?.league_name,
                            country_name: data?.country_name,
                            country_logo: data?.country_logo,
                            match_stadium: data?.match_stadium,
                            match_time: data?.match_time,
                            match_date: data?.match_date,
                            stage_name: data?.stage_name,
                        }

                    } />
                    {/* <MatchResultCard /> */}
                </div>
            </main>
        </>
    )
}

export default Match;